<template lang="pug">
    app-layout
        template(slot="content")
            app-login
</template>

<script>
//Components
import Layout from '@/components/layouts';
import LoginForm from '@/components/views/login/';

export default {
    name: "home",
    components: {
        'app-layout': Layout,
        'app-login': LoginForm,
    }
}
</script>